import { checkCostShares, costShare } from './schedule-cost-split.js';
export const serviceChargeScheduleTypes = ['General', 'Residential', 'Commercial', 'Estate', 'Building', 'Block', 'Core', 'Lift', 'Car park', 'Reserve', 'Custom', 'Other'];
/** Legacy percentage/fraction rows remain usable. New weighted rules need explicit reviewed provenance. */
export function allocationShare(row) {
    const terms = row.source_values?.terms, weighted = ['Fixed share', 'Variable'].includes(row.method);
    if ((terms || weighted) && (!terms || terms.verification !== 'Verified' || terms.purpose !== 'Lease apportionment' || !terms.sourceClause.trim() || !terms.sourceReference.trim() || weighted && !terms.basis.trim()))
        throw Error('Verify the lease clause, source reference and calculation basis; temporary budget proposals cannot be charged.');
    if (row.method === 'Percentage' && row.share_percent !== null)
        return `${row.share_percent}%`;
    if ((row.method === 'Fraction' || weighted) && row.numerator !== null && row.denominator !== null)
        return `${row.numerator}/${row.denominator}`;
    throw Error('Manual, missing or invalid shares require review.');
}
/** Recorded presence is a declaration, never an assessment of compliance. */
export const mobilisationSafetySystems = [
    ['fire_alarm', 'Fire alarm'], ['emergency_lighting', 'Emergency lighting'],
    ['smoke_control', 'Smoke control'], ['sprinklers', 'Sprinklers'], ['dry_riser', 'Dry riser'],
    ['wet_riser', 'Wet riser'], ['firefighting_lift', 'Firefighting lift'],
    ['aov', 'Automatic opening vents'], ['suppression', 'Suppression systems'], ['safety_other', 'Other'],
];
export function premisesProgress(expectedResidential, recordedResidential, commercialStatus, expectedCommercial, recordedCommercial, provisional = 0) {
    const known = commercialStatus === 'No' || commercialStatus === 'Yes' && expectedCommercial !== null;
    const reconciled = known && expectedResidential === recordedResidential && (commercialStatus === 'No' ? 0 : expectedCommercial) === recordedCommercial;
    return { reconciled, state: provisional ? 'Needs attention' : recordedResidential + recordedCommercial === 0 && expectedResidential + (expectedCommercial ?? 0) > 0 ? 'Incomplete' : 'Complete',
        detail: `${recordedResidential} flats; ${recordedCommercial} commercial premises.${provisional ? ` ${provisional} imported identities need review.` : ''}` };
}
export function allocationProgress(rows) {
    const seen = new Set();
    let total = 0;
    const errors = [], shares = [];
    for (const row of rows) {
        if (seen.has(row.premises_id))
            errors.push('A premises appears more than once.');
        seen.add(row.premises_id);
        try {
            const text = allocationShare(row), share = costShare(text);
            shares.push(text);
            total += Number(share.n) / Number(share.d) * 100;
        }
        catch (e) {
            errors.push(e.message);
        }
    }
    if (!rows.length)
        errors.push('No allocations are recorded.');
    try {
        checkCostShares(shares);
        if (!shares.length)
            throw Error();
    }
    catch {
        errors.push('Allocations do not total exactly 100% or the defined total shares.');
    }
    return { complete: errors.length === 0, total: errors.length === 0 ? 100 : total, errors: [...new Set(errors)] };
}
//# sourceMappingURL=mobilisation.js.map